import { ClientEvent, Guest } from "../domain/events";
import { getAllGuestsService } from "../infrastructure/services/getAllGuestsService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const getAllGuests = {
  async execute(): Promise<Guest[]> {
    const clientsGuests: ClientEvent[] = await getAllGuestsService.execute(
      await tokenValidation.execute()
    );
    return clientsGuests.flatMap((client) => client.guests);
  },
};
